import React from 'react'
import { useMediaQuery } from 'react-responsive'

const TabletView = ({ children }) => {
    const isIpad = useMediaQuery({ minWidth: 501, maxWidth: 1200 })
    return isIpad && children;
}

export default TabletView
